module.exports = __webpack_public_path__ + "img/ttf-logo.219b163b.png";